/* INDEX FILE
It exports as default the reducer function of the duck.
It exports as named export the selectors and the operations.
Optionally it exports the actions and types if they are needed in other ducks.
*/

import reducers from "./reducers";

import homeService from "./service";
import homeTypes from "./types";
import homeActions from "./actions";

export { homeService, homeActions, homeTypes };

export default reducers;
